export default {
  onboardingInfoBlockContent: {
    id: 'profile_page_legal_details_tab_onboarding_info_block_content',
    defaultMessage:
      'Add your legal and tax information below to start selling on BackMarket.',
  },
  infoBlockTitle: {
    id: 'profile_page_legal_details_tab_info_block_title',
    defaultMessage: 'You’re almost there!',
  },
  onboardingModalTitle: {
    id: 'profile_page_legal_details_tab_onboarding_modal_title',
    defaultMessage: 'Add legal docs and details',
  },
  onboardingModalDescription: {
    id: 'profile_page_legal_details_tab_onboarding_modal_description',
    defaultMessage:
      'Before activating your account, our team will need to verify your business details.',
  },
  onboardingModalToDoSection: {
    id: 'profile_page_legal_details_tab_onboarding_modal_to_do_section',
    defaultMessage:
      'Upload your ID, certificate of registration, and article of association. Then add your tax and EPR details.',
  },
  onboardingModalDoneSection: {
    id: 'profile_page_legal_details_tab_onboarding_modal_done_section',
    defaultMessage: 'Head back to the Onboarding page to continue.',
  },
  onboardingModalButtonLabel: {
    id: 'profile_page_legal_details_tab_onboarding_modal_button_label',
    defaultMessage: 'Add details',
  },
}
